import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  CardTitle,
  CardSubtitle,
  Container,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation";
import showNotification from "../../../helpers/show_notification";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import TagsInput from "react-tagsinput";
import exportFromJSON from "export-from-json";
import { postSubmitForm } from "../../../helpers/forms_helper";
// actions

const AllEqiCategories = (props) => {
  const { SearchBar } = Search;
  useEffect(() => {
    loadAllCategories();
  }, []);

  const [allCategories, setAllCategories] = useState([]);
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "equipmentcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [isLoading , setIsLoading] = useState(false)
  const handleValidUpdate = async (e, v) => {
    try {
      const object = {
        id: selectedCategory._id,
        category: v.name,
        sub_category: subCategories,
      };
      setIsLoading(true)
      let url = process.env.REACT_APP_BASEURL + "equipmentcategories/update";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        loadAllCategories();
        setSubCategories([]);
        setEditModal(!editModal);
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error.message, "Error");
    } finally {
      setIsLoading(false)
    }
  };

  const [selectedCategory, setSelecetedCategory] = useState();
  const [subCategories, setSubCategories] = useState();
  const [editModal, setEditModal] = useState();
  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      text: props.t("Category Name"),
      //formatter: employeeFormatter,
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "16%" };
      },
    },
    {
      text: props.t("Sub-Categories"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            {row.sub_category.map((subcategory) => {
              return (
                <span class="font-size-12 mr-2 badge-soft-success badge badge-success badge-pill">
                  {subcategory}
                </span>
              );
            })}
          </>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "35%" };
      },
    },
    {
      text: props.t("Action"),
      sort: false,
      formatter: (cell, row) => {
        return (
          <span className="text-info">
            <i
              className="bx bxs-edit font-size-15"
              title="Click to Edit"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setEditModal(!editModal);
                setSelecetedCategory(row);
                setSubCategories(row.sub_category);
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
  ];
  const handleDownload = async () => {
    const fileName = "allEqiuipmentCategories";
    const exportType = "xls";

    let data_to_export = allCategories;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          category: v.category,
          sub_category: v.sub_category.map((cat)=>cat).join(", "),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };
  function printDiv(divName) {
    let printContents = document.getElementById(divName);
    // Remove the Action column
    const tempElement = document.createElement("div");
    tempElement.innerHTML = printContents.innerHTML;
    const actionColumns = tempElement.querySelectorAll("th:nth-child(4), td:nth-child(4)");
    actionColumns.forEach(col => col.remove());
  
    let searchelement = tempElement.getElementsByClassName("sr-only");
  
    if (searchelement && searchelement[0]?.parentNode) {
      searchelement[0].parentNode.removeChild(searchelement[0]);
    }
  
    let subCategoryElements = tempElement.getElementsByClassName("badge-pill");
    Array.from(subCategoryElements).forEach((element) => {
      element.style.display = "inline-block";
      element.style.marginRight = "5px";
      element.style.marginBottom = "3px";
    });
  
    let winPrint = window.open("", "", "left=0,top=0,toolbar=0,scrollbars=0,status=0");
    winPrint.document.write(
      `<title>${divName} Report</title>
      <head>
        <style>
          table {
            table-layout: fixed;
            font-family: "Poppins", sans-serif;
            border: 1px solid #eff2f7;
            font-size: 12px;
            border-collapse: collapse;
            max-width: 100%;
            color: #495057;
        
          
            margin-bottom: 1rem;
            margin-top: 1rem;
          }
          
          for-print-heading {
            font-size: 16px;
            margin: 0 0 7px 0;
            font-weight: bold;
          }

          for-print-sub_heading {
            font-size: 14px;
            margin: 0 0 7px 0;
            font-weight: normal !important;
          }

          table td, table th {
            border: 1px solid #ddd;
            padding: 8px;
          }
          
          table tr:nth-child(even){background-color: #f2f2f2;}
          
          table tr:hover {background-color: #ddd;}
          
          table th {            
            text-align: left;
          }
             .badge-pill {
          display: inline-block;
          margin-right: 5px;
          margin-bottom: 3px;
        }
        </style>
      </head>
      <body>
        ${tempElement.innerHTML}
      </body>
    `);
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
  }
  

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Equipment Category")}
            breadcrumbItem={props.t("Update Equipment Category")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("All Equipment Categories")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t(
                      "View/Update all your existing equipment categories here"
                    )}
                  </CardSubtitle>

                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"  "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>

                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allCategories && allCategories}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              {" "}
                              <CardTitle>Equipment Category</CardTitle>
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    isOpen={editModal}
                    toggle={() => setEditModal(!editModal)}
                  >
                    <ModalHeader toggle={() => setEditModal(!editModal)}>
                      {props.t("Update Equipment Category")}
                    </ModalHeader>
                    <ModalBody>
                      {selectedCategory && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <AvForm onValidSubmit={handleValidUpdate}>
                                    <Row>
                                      <Col lg={6}>
                                        <AvField
                                          name="name"
                                          value={selectedCategory.category}
                                          label={props.t("Category")}
                                          placeholder={props.t(
                                            "Enter Category Name"
                                          )}
                                          type="text"
                                          validate={{
                                            required: {
                                              value: true,
                                              errorMessage: props.t(
                                                "Name cannot be empty"
                                              ),
                                            },
                                          }}
                                        />
                                      </Col>{" "}
                                      <Col lg={6}>
                                        <Label>
                                          {props.t("Sub-Category Name")}
                                        </Label>{" "}
                                        ({props.t("press ENTER/TAB to add")})
                                        <TagsInput
                                          value={subCategories}
                                          onChange={(tags) => {
                                            setSubCategories(tags);
                                          }}
                                          onlyUnique={true}
                                          inputProps={{
                                            className: "react-tagsinput-input",
                                            placeholder: props.t("Add..."),
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col lg={12}>
                                        <FormGroup className="mb-0 text-center">
                                        <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isLoading} style={{width:"100px"}}>
                          { isLoading ? <Spinner size={"sm"}/> :props.t("Update")}
                        </Button>
                      </div>
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </AvForm>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(AllEqiCategories))
);
